import { apiClient, type PageEntity, type ChargeTypeEntity } from '@/libs/api'
import { type ChargeTypesListRequestQuery } from '@/libs/api/types'

export type FetchChargeTypesListQuery = {
  tenantKey: string
  query?: ChargeTypesListRequestQuery
}

export type FetchChargeTypesListResponse = {
  data: ChargeTypeEntity[]
  pagination: PageEntity | null
}

// 運賃種別マスタ管理画面用一覧取得API（#4209: ADMIN は全拠点表示）
export const fetchChargeTypesList = async (
  { tenantKey, query }: FetchChargeTypesListQuery,
  signal?: AbortSignal
): Promise<FetchChargeTypesListResponse> => {
  const { data, pagination } = await apiClient
    ._tenant(tenantKey)
    .charge_types.list.$get({
      query,
      config: {
        signal
      }
    })
  return { data, pagination }
}
